import {Button,Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import React, { useContext } from "react";
import Lang from "../../../components/Lang";
import Text from "../../../components/Text";
import { ClassesContext } from "../../../../../Context";
import DatePicker from "../../../components/DatePicker";
import mut from "../../../hooks/mut";

export default function EditNameDialog(props) {
    const { open, setOpen, lesson, setClasses,week } = props;
    const [name, setName] = React.useState(lesson.name);
    const [changeDate, setChangeDate] = React.useState(undefined);
    const { classDays } = useContext(ClassesContext)
   
    const change = async () => {
        let res = await mut("post", `/change-class-name/${lesson.htClass}/${week}`, { name, changeDate })
        console.log(res)
        setClasses(res)
        setOpen(false)
    }

  return (
    <Dialog open={open}>
      <DialogTitle><Lang w="changeTheName" /></DialogTitle>
          <DialogContent style={{display:"flex",flexDirection:"column",gap:15, paddingTop:10}}>
        <Text value={name} setValue={setName} label={<Lang w="name" />} size="small"/>
        <DatePicker value={changeDate} setValue={setChangeDate} label={<Lang w="dateToChange" />} daysToEnable={classDays(lesson.htClass)} />
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={() => setOpen(false)}>Close</Button>
        <Button color="success" disabled={!changeDate} onClick={change}>Go</Button>
      </DialogActions>
    </Dialog>
  );
}